import * as React from 'react';
import CombineViewCell from './combineViewCell';
import { combinedViewDateLabel } from './dateKey';

/**
 * One day of the timeline.
 *
 * The header renders the group key directly. The shared GetDate component is no
 * longer used here: it reverse-engineers a date by splitting a locale-formatted
 * string against the user's date-format preference, which only worked while the
 * server sent that pre-formatted string. The key is now an unambiguous
 * YYYY-MM-DD produced from the entry timestamp.
 */
export default function CombinedViewGroup({ data, extraData }) {
    return (
        <div className={"combinedListingGroup detailListingGroup "}>

            <div className="date"><span>{combinedViewDateLabel(data.key)}</span></div>
            {data.data.map((d) => {
                return <React.Fragment key={d.id}><CombineViewCell data={d.data} extraData={extraData}/></React.Fragment>
            })}
        </div>
    );
}
